var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserMinimal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#user-minimal_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12.704a6.351 6.351 0 10-6.352-6.352A6.36 6.36 0 0012 12.704zm0-10.812a4.459 4.459 0 11-4.46 4.46A4.464 4.464 0 0112 1.895v-.003zM1.93 25.811c0-5.553 4.517-10.07 10.07-10.07s10.07 4.517 10.07 10.07h1.895a11.965 11.965 0 00-20.425-8.46 11.886 11.886 0 00-3.505 8.46H1.93z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user-minimal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgUserMinimal;